export default __webpack_public_path__ + "static/media/cp_geo_mm.f6c8607e.svg";